import React from "react";
import "./Take_Your_Goal.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import { useNavigate } from "react-router-dom";

const Take_Your_Goal = () => {
  const navigate = useNavigate();
  return (
    <section id="take-your-goal" className="take_your_goal">
      <div className="container-fluid">
        <div className="goal_banner_holder">
          <h2 className="title">Take Your Goals Beyond Horizon</h2>
          <p className="register">
            REGISTER ON <span className="span_1">Gym</span>
            <span className="span_2">ify</span> AS
          </p>

          <div className="gym_btn_holder">
            <Common_Btn
              btnText="Gym Member"
              onClick={() => navigate("/login-flow?role=member")}
            />

            <Common_Btn
              btnText="Gym Owner"
              onClick={() => navigate("/login-flow?role=owner")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Take_Your_Goal;
